export default {
  list: '/portal/smokeProfiles/',
  entity: '/portal/smokeProfiles/:id/',
}
